import { App } from "../App";
import { IMap } from "../IMap";
import * as Cookies from "js-cookie";

export class MainUi
{
    private app: App;

    constructor(_app: App)
    {
        this.app = _app;

        let sync = document.querySelector(".syncing");
        let lastSync = Cookies.get("lastSync");
        if (sync)
        {
            if (lastSync)
            {
                let date = new Date(parseInt(lastSync));
                sync.innerHTML = "Last synced " + date.toLocaleTimeString();
            }
            else
            {
                sync.classList.add("hidden");
            }
        }

        let search = document.querySelector(".search > form > input");
        if (search)
        {
            let params = new URLSearchParams(window.location.search);
            let searchQueryString = params.get("search");

            if (searchQueryString)
            {
                (search as HTMLInputElement).value = searchQueryString;
            }

            search.addEventListener("keydown", this.onSearchInputChanged.bind(this));
            search.addEventListener("paste", this.onSearchInputChanged.bind(this));
            search.addEventListener("input", this.onSearchInputChanged.bind(this));
        }

        let btnGrid = document.querySelector(".btn-grid");
        if (btnGrid)
        {
            btnGrid.addEventListener("click", this.onToggleGridClicked.bind(this));
        }

        let raMaps = document.querySelector(".ra-maps");
        if (raMaps)
        {
            raMaps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "ra"), false);
        }

        let tdMaps = document.querySelector(".td-maps");
        if (tdMaps)
        {
            tdMaps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "td"), false);
        }

        let d2Maps = document.querySelector(".d2-maps");
        if (d2Maps)
        {
            d2Maps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "d2"), false);
        }

        let tsMaps = document.querySelector(".ts-maps");
        if (tsMaps)
        {
            tsMaps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "ts"), false);
        }

        let yrMaps = document.querySelector(".yr-maps");
        if (yrMaps)
        {
            yrMaps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "yr"), false);
        }

        let dtaMaps = document.querySelector(".dta-maps");
        if (dtaMaps)
        {
            dtaMaps.addEventListener("click", (e: Event) => this.onMapTypeChanged(e, "dta"), false);
        }

        this.setDefaultMenu(this.app.activeGameSelected);
        this.buildSkeletonResults();
    }

    private buildSkeletonResults(): void
    {
        let resultDiv: HTMLDivElement = document.querySelector(".results") as HTMLDivElement;

        for (let i = 0; i < 30; i++)
        {
            let resultItem = document.createElement("div");
            resultItem.classList.add("skeleton");
            resultItem.innerHTML += `
                <div class="date"></div>
                <div class="hash"></div>
                <div class="game"></div>
                <a href="#"></a>
            `
            resultDiv.appendChild(resultItem);
        }
    }

    /**
     * Toggle grid style view for results
     */
    private onToggleGridClicked(): void
    {
        let results = document.querySelector(".results");

        if (results)
        {
            results.classList.toggle("grid");
        }

        let btn = document.querySelector(".btn-grid");
        if (btn)
        {
            btn.classList.toggle("grid-active");
        }
    }

    private onMapTypeChanged(e: Event, game: string): any
    {
        e.preventDefault();
        e.stopPropagation();

        this.app.changeMapsByGame(game);
        this.setDefaultMenu(game);

        return false;
    }

    private setDefaultMenu(game: string): void
    {
        var menuLinks = document.querySelectorAll(".menu-links > a");
        for (let i = 0; i < menuLinks.length; i++)
        {
            menuLinks[i].classList.remove("active");
        }

        var activeEl = document.querySelector("." + game + "-maps");
        if (activeEl)
        {
            activeEl.classList.add("active");
        }
    }

    /**
     * Upon search input changing, update teh results
     */
    private onSearchInputChanged(): void
    {
        let searchTerm: string = "";
        let searchBox = document.querySelector(".search form > input");
        if (searchBox)
        {
            searchTerm = (searchBox as HTMLInputElement).value;
        }

        this.onSearchInputValueChanged(searchTerm);
    }

    /**
     * Searches results from @see Search
     * @param searchTerm 
     */
    private onSearchInputValueChanged(searchTerm: string): void
    {
        let results: Array<IMap> = this.app.search.searchByName(searchTerm);
        this.updateResults(results, 30);
    }

    /**
     * Updates the search results in the UI
     * @param results 
     * @param limit 
     */
    public updateResults(results: Array<IMap>, limit: number): void
    {
        let resultDiv: HTMLDivElement = document.querySelector(".results") as HTMLDivElement;
        if (!resultDiv)
        {
            return;
        }

        resultDiv.innerHTML = "";

        for (let i: number = 0; i < results.length; i++)
        {
            let map: IMap = results[i];
            let resultItem = this.createResult(map);

            resultDiv.appendChild(resultItem);

            // Limit results rendered
            if (i > limit)
            {
                break;
            }
        }
    }

    private createResult(map: IMap): any
    {
        let resultItem = document.createElement("div");
        let resultLink = document.createElement("a");
        resultLink.href = "http://mapdb.cncnet.org/" + map.game + "/" + map.hash + ".zip";

        resultLink.innerHTML += map.name;
        resultItem.innerHTML += `
            <div class="date"><strong>Date: </strong>${map.date}</div>
            <div class="hash"><strong>Hash: </strong>${map.hash}</div>
            <div class="game"><i class="icon icon-game icon-${map.game}"></i></div>
        `;

        resultItem.appendChild(resultLink);

        return resultItem;
    }

    /**
     * Refresh results - e.g use when data has changed
     */
    public render(): void
    {
        this.onSearchInputChanged();
    }
}